export default "__VITE_ASSET__Br96eCYF__"